import { i18n } from "@lingui/core";
import { msg } from "@lingui/core/macro";

import { multiResumeBrand } from "@/utils/multiresume-brand";

export const homeMetadataMessages = {
  title: msg({
    id: "growth.home.metadata-title",
    message: "Tailor Your Resume to a Job Description",
  }),
  description: msg({
    id: "growth.home.metadata-description",
    message:
      "Bring your resume and a job description, review tailored suggestions one by one, and export your resume for the role. MultiResume is currently invite-only.",
  }),
} as const;

export function getHomeMetadata() {
  const title = i18n._(homeMetadataMessages.title);
  const description = i18n._(homeMetadataMessages.description);

  return {
    title: `${title} | ${multiResumeBrand.appName}`,
    description,
  };
}
